<template>
    <div>
        <Card>
            <p slot="title"> Hapus Piutang (Administrator) </p>

            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Marking</Button>
                        <Select
                            style="width: 250px;"
                            v-model="markingIdSelected"
                            filterable
                            clearable
                            :remote-method="getMarkingByCode"
                            :loading="isLoadingMarking"
                            @on-change="updateFilter">
                            <Option v-for="option in optionMarkings"
                                :value="option.value" :key="option.value">{{option.label}}</Option>
                        </Select>
                    </ButtonGroup>
                </Col>
                <Col span="6">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Tgl. Transaksi</Button>
                        <Date-picker
                            v-model="transactionDate"
                            style="width: 180px;"
                            type="daterange"
                            format="yyyy-MM-dd"
                            @on-change="updateFilter">
                        </Date-picker>
                    </ButtonGroup>
                </Col>
                <Col span="4">
                    <Button
                        type="primary"
                        :loading="loadingGetReceivable"
                        icon="ios-search"
                        @click="getReceivableData"
                        v-show="isSearchShow">
                            <span v-if="!loadingGetReceivable">Cari</span>
                            <span v-else>Wait.....</span>
                    </Button>
                </Col>
                <Col span="4">
                    <Spin size="large" v-show="loadingGetReceivable"></Spin>
                </Col>
            </Row>

            <br>

            <Card v-show="receivables.length > 0">
                <Table :columns="tableColumns" :data="receivables" @on-row-click="showDeleteReceivable"></Table>
            </Card>

            <Modal v-model="modalConfirmDelete" width="500px" @on-cancel="confirmMarkingheadercode = ''">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Konfirmasi</span>
                </p>
                <div style="text-align:left">
                    <h4>{{receivableToDelete.markingheadercode}} : {{receivableToDelete.transactionDate}}</h4>
                    <p>Keterangan : <br/>{{receivableToDelete.description}}</p>
                    <hr/>
                    <p>Debit Amount     : Rp <b>{{ receivableToDelete.debitAmount}} </b></p>
                    <br/>
                    <p> Ketik <b>{{receivableToDelete.markingheadercode}}</b> untuk Lanjut</p>
                    <br/>
                    <Input v-model="confirmMarkingheadercode" />
                </div>
                <div slot="footer">
                    <Button
                        type="error" size="large" long :loading="loadingConfirmDelete" @click="deleteReceivable"
                        v-show="receivableToDelete.markingheadercode == confirmMarkingheadercode.toUpperCase()"
                        >Hapus</Button>
                </div>
            </Modal>

        </Card>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');

export default {
    data: () => ({
        markingIdSelected : '',
        optionMarkings : [],
        loadingGetMarking: false,
        transactionDate: [],
        isLoadingMarking: false,
        isSearchShow: false,

        confirmMarkingheadercode : '',
        modalConfirmDelete: false,
        modal : {
            deleteReceivable : false
        } ,
        loadingConfirmDelete : false,

        loadingGetReceivable: false,
        receivables : [],
        receivableToDelete: [],
        tableColumns: [
            {
                title: 'Tgl',
                key: 'transactionDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                sortable: true
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Debit Amount',
                align : 'right',
                key: 'debitAmount',
                sortable: false
            }
        ]
    }),

    methods: {
      getMarkingByCode: _.debounce(
          function (query) {
              if (query !== '') {
                  this.loadingGetMarking = true;

                  HTTP
                  .post('marking/getBySnapshot', {
                      markingHeaderId: query,
                      subbranchcode: this.subbranchcode
                  })
                  .then(response => {
                      this.loadingGetMarking = false;
                      let data = response.data;

                      const list = data.map(item => {
                          return {
                              value: item.markingheaderid,
                              label: item.markingheadercode
                          };
                      });

                      this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                  })
                  .catch(e => {
                      this.loadingGetMarking = false;
                      this.$Notice.error({
                          title: "Error",
                          desc: e,
                          duration: 5
                      });
                  })
              } else {
                  this.optionMarkings = [];


              }
          }, 400
      ),

      getReceivableData: function(){
          let parent = this;
          this.receivables = []

          let startTransactionDate = null;
          let endTransactionDate = null;
          let markingIdSelected = null

          if(this.markingIdSelected != "") {
            markingIdSelected = this.markingIdSelected
          }

          if(this.transactionDate[0] != "" && this.transactionDate[0] != null) {
            startTransactionDate = moment(this.transactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
            endTransactionDate = moment(this.transactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          let payload = {
            markingHeaderId : markingIdSelected,
            startTransactionDate : startTransactionDate,
            endTransactionDate : endTransactionDate
          }

          this.loadingGetReceivable = true;
          HTTP
          .post('receivable/administrator/delete/show', payload)
          .then(response => {
              console.log({response});

              let receivables = []
              _.forEach(response.data, function(value){
                  let receivable = {
                      receivableId : value.id,
                      transactionDate : parent.showDateFormatted(value.transactionDate),
                      markingHeaderId : value.markingHeaderId,
                      markingheadercode : value.marking_minified.markingheadercode,
                      description : value.description,
                      debitAmount : numeral(value.debitAmount).format('0,0'),
                  }
                  receivables.push(receivable);
              });

              this.receivables = receivables;
              this.loadingGetReceivable = false;

          })
          .catch(e => {
              this.loadingGetReceivable = false;
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          });
      },
      showDateFormatted : function(stringToFormat){
          let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
          return moment(dateToFormat).format("DD MMM YYYY")
      },
      showDeleteReceivable: function(receivableToDelete) {
          this.receivableToDelete = receivableToDelete
          this.modalConfirmDelete = true
      },
      deleteReceivable: function() {
          this.loadingConfirmDelete = true
          let receivableToDelete = this.receivableToDelete;

          HTTP
          .post('receivable/delete', {
              receivableId: receivableToDelete.receivableId
          })
          .then(response => {
              this.modalConfirmDelete = false
              this.loadingConfirmDelete = false
              this.receivableToDelete = []

              this.$Message.success({
                  content: 'Data Telah Terhapus',
                  duration: 4
              });
              console.log(response);
              this.getReceivableData();
          })
          .catch(e => {
              this.modalConfirmDelete = false
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          })
      },
      updateFilter: function() {
          const markingIdSelected = this.markingIdSelected
          const transactionDate = this.transactionDate

          if ((markingIdSelected == '' || markingIdSelected == undefined) && transactionDate[0] == '') {
            this.isSearchShow = false
          } else {
            this.isSearchShow = true
          }
      }
    },
}

</script>



// WEBPACK FOOTER //
// AdministratorReceivableDelete.vue?3aa60cc6